/**
 * ROTAS69 search panel wiring.
 *
 * Вынесен из инлайна snippets/search-modal.liquid 30.08.2026. Это был САМЫЙ КРУПНЫЙ наш инлайновый
 * блок на странице — 18 167 символов из 226 892 по всем 58 блокам главной. Shopify не минифицирует
 * инлайн, но минифицирует assets/*.js на 54–62 % (проверено на utilities, theme-drawer,
 * product-card), и ассет с `?v=<хэш>` кэшируется между страницами, а инлайн разбирается заново
 * на каждой навигации.
 *
 * СТАРЫЙ КОММЕНТАРИЙ, КОТОРЫЙ ЗАПРЕЩАЛ ЭТОТ ПЕРЕНОС, ПРОВЕРЕН И ОКАЗАЛСЯ УСТАРЕВШИМ.
 * Он говорил, что исполнение при парсинге нужно, чтобы «застолбить флаг r69SearchBound раньше
 * устаревшей копии из скомпилированного бандла». Грепом по всей теме: `r69SearchBound`
 * встречается ТОЛЬКО здесь. Второй копии не существует, защищаться не от чего. Второй довод
 * комментария — отставание компилируемого бандла — относится к компилируемому бандлу сниппет-скриптов, а не к
 * assets/*.js, у которых версионный хэш в имени.
 *
 * Позднее исполнение безопасно и было предусмотрено автором: файл заканчивается boot() плюс
 * повтором на DOMContentLoaded, а init защищён флагом dataset.r69SearchBound от двойного запуска.
 * С `defer` первая ветка просто находит уже разобранную разметку. Панель на загрузке закрыта,
 * поэтому позднее навешивание слушателей визуально ничего не меняет.
 *
 * ЕСЛИ БУДЕШЬ ПРАВИТЬ: файл статический, Liquid внутрь не класть (внутри блока его и не было).
 */
(function () {
  const setTop = (fs) => {
    // Anchor the panel directly under the top header row.
    const anchor =
      fs.closest('.header__row--top') ||
      fs.closest('.header__row') ||
      document.querySelector('#header-component') ||
      fs;
    const bottom = anchor.getBoundingClientRect().bottom;
    const panel = fs.querySelector('.predictive-search-form__content-wrapper');
    if (!panel) {
      fs.style.setProperty('--r69-panel-top', Math.max(0, Math.round(bottom)) + 'px');
      fs.style.setProperty('--r69-panel-viewport-top', Math.max(0, Math.round(bottom)) + 'px');
      return;
    }
    // Compensate for any positioned ancestor that becomes the fixed containing block:
    // neutralise the slide transform, measure where top:0 lands, then offset so the panel
    // sits flush at the header bottom.
    const prevTransform = panel.style.transform;
    const prevTransition = panel.style.transition;
    panel.style.transition = 'none';
    panel.style.transform = 'none';
    fs.style.setProperty('--r69-panel-top', '0px');
    const base = panel.getBoundingClientRect().top;
    fs.style.setProperty('--r69-panel-top', Math.max(0, Math.round(bottom - base)) + 'px');
    // …and separately, where the panel really starts ON SCREEN. The variable above is an offset
    // inside a positioned ancestor — header-component becomes the fixed containing block — so it
    // reads 102 while the panel starts at 137. A height derived from it ran 35px past the bottom
    // of the screen, and that strip could not be scrolled to: the last row of cards sat under the
    // phone's navigation bar. The anchor's bottom IS the panel's screen top, so it is written on
    // its own and the height uses this one.
    fs.style.setProperty('--r69-panel-viewport-top', Math.max(0, Math.round(bottom)) + 'px');
    panel.style.transform = prevTransform;
    panel.style.transition = prevTransition;
  };

  const init = (fs) => {
    if (fs.dataset.r69SearchBound) return;
    fs.dataset.r69SearchBound = 'true';
    const input = fs.querySelector('.search-input');
    const content = fs.querySelector('.predictive-search-form__content');
    const resetBtn = fs.querySelector('.predictive-search__reset-button');
    const closeBtn = fs.querySelector('.r69-search__close');
    const emptyHTML = content ? content.innerHTML : '';
    const lockScroll = (on) => {
      // Reserve the scrollbar width so the page does not shift when the lock hides it (same var +
      // rule the drawers/quick-add use, in base.css). Only write a real, visible width; clear it
      // only when no other lock (drawer / quick-add via [scroll-lock]) is still holding it.
      if (on) {
        const sbw = window.innerWidth - document.documentElement.clientWidth;
        if (sbw > 0) {
          document.documentElement.style.setProperty('--r69-scrollbar-comp', sbw + 'px');
          document.documentElement.setAttribute('scrollbar-comp', '');
        }
      } else if (!document.documentElement.hasAttribute('scroll-lock')) {
        document.documentElement.style.setProperty('--r69-scrollbar-comp', '0px');
        document.documentElement.removeAttribute('scrollbar-comp');
      }
      document.documentElement.classList.toggle('r69-search-lock', on);
    };

    // NO portal, deliberately. The component never leaves its place in the header: the panel
    // (.predictive-search-form__content-wrapper) is position:fixed and setTop() below already
    // compensates for whatever containing block the header imposes — the same math the desktop
    // dropdown has always used. The previous mobile design moved the whole component to <body>
    // and froze real input on phones; nothing here mutates the DOM's shape at all.

    // ---- Recently viewed: MAINTAINED CONTENT, not a one-shot fill. --------------------------
    // The old design filled the row once (ps.js #resetSearch) and only maintained a SKELETON.
    // Any later wipe of the panel — and several actors morph it — left an empty container that
    // nothing would ever refill: the row appeared, vanished, and the skeleton pulsed forever
    // (the 12s failsafe removed it, and the observer put it straight back — a proven loop).
    // Now the same observer maintains the CARDS: an empty recent container with a non-empty
    // history triggers a fetch of the real-card wrapper (sections/r69-search-cards, the same
    // markup ps.js prepends), cached per id-list so a repeat wipe refills instantly. One
    // failure per id-list stops the skeleton too — no eternal pulsing; retry on next open.
    const viewedIds = () => {
      try {
        const ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
        return Array.isArray(ids) ? ids : [];
      } catch (error) {
        return [];
      }
    };
    // The JSON-instance section id: derived from the card seed's auto wrapper, present in every
    // page's DOM (both live in the footer group). Same derivation as predictive-search.js.
    const r69SectionId = () => {
      const seed = document.querySelector('[id^="shopify-section-sections--"][id$="__r69_card_seed"]');
      return seed ? seed.id.replace('shopify-section-', '').replace('__r69_card_seed', '__r69_search_cards') : null;
    };
    let recentCache = { sig: '', html: '' };
    let recentInflight = '';
    let recentFailedSig = '';
    const dropSkeleton = (recent) => {
      const skel = recent.querySelector('[data-r69s-skel]');
      if (skel) skel.remove();
    };
    const fillRecent = () => {
      const recent = fs.querySelector('.r69s-search__recent');
      if (!recent) return;
      const hasRealContent = [...recent.children].some((child) => !child.hasAttribute('data-r69s-skel'));
      if (hasRealContent) { dropSkeleton(recent); return; }
      const ids = viewedIds();
      if (!ids.length) { dropSkeleton(recent); return; }
      const sig = ids.join(',');
      if (recentCache.sig === sig && recentCache.html) {
        recent.insertAdjacentHTML('afterbegin', recentCache.html);
        dropSkeleton(recent);
        return;
      }
      if (recentInflight === sig || recentFailedSig === sig) return;
      const sid = r69SectionId();
      if (!sid) return;
      recentInflight = sig;
      const u = new URL(Theme.routes.search_url, location.origin);
      u.searchParams.set('q', ids.map((id) => 'id:' + id).join(' OR '));
      u.searchParams.set('resources[type]', 'product');
      // History is history: a product the shopper opened stays in this row after it sells
      // out. Search hides out-of-stock products by default (Search & Discovery), which
      // silently pruned them here — the carousel and the wishlist pass the same flag.
      // Draft/unlisted are never returned regardless, which is correct.
      u.searchParams.set('options[unavailable_products]', 'show');
      u.searchParams.set('section_id', sid);
      // Marker for sections/r69-search-cards.liquid (see predictive-search.js): the payload is
      // rendered only for section fetches carrying this view (template.suffix).
      u.searchParams.set('view', 'r69-panel');
      fetch(u.toString())
        .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then((t) => {
          const doc = new DOMParser().parseFromString(t, 'text/html');
          const tpl = doc.querySelector('template[data-r69-search-payload]');
          const wrapper = tpl && tpl.content.querySelector('.recently-viewed-wrapper');
          if (!wrapper) throw new Error('no wrapper in payload');
          wrapper.setAttribute('ref', 'recentlyViewedWrapper');
          recentCache = { sig, html: wrapper.outerHTML };
          recentInflight = '';
          const again = fs.querySelector('.r69s-search__recent');
          if (!again) return;
          const filled = [...again.children].some((child) => !child.hasAttribute('data-r69s-skel'));
          if (!filled && viewedIds().join(',') === sig) {
            again.insertAdjacentHTML('afterbegin', recentCache.html);
          }
          dropSkeleton(again);
        })
        .catch(() => {
          recentInflight = '';
          recentFailedSig = sig;
          const again = fs.querySelector('.r69s-search__recent');
          if (again) dropSkeleton(again);
        });
    };
    const syncRecentSkeleton = () => {
      const recent = fs.querySelector('.r69s-search__recent');
      if (!recent) return;
      const skel = recent.querySelector('[data-r69s-skel]');
      const hasRealContent = [...recent.children].some((child) => !child.hasAttribute('data-r69s-skel'));
      if (hasRealContent) {
        if (skel) skel.remove();
        return;
      }
      if (skel) return;
      const ids = viewedIds();
      const count = Math.min(ids.length, 4);
      if (count === 0) return;
      // A fetch for this exact id-list already failed — show nothing rather than pulse forever.
      if (recentFailedSig === ids.join(',')) return;
      let cards = '';
      for (let i = 0; i < count; i++) cards += '<span class="r69s-skel__card"></span>';
      const next = document.createElement('div');
      next.className = 'r69s-skel';
      next.setAttribute('data-r69s-skel', '');
      next.innerHTML = '<span class="r69s-skel__eyebrow"></span><div class="r69s-skel__row">' + cards + '</div>';
      recent.appendChild(next);
    };
    // Debounced: the observer below fires on every results morph while typing; the sync itself
    // bails in one querySelector when the recent container is absent. Appending the skeleton
    // or the cards re-fires the observer once, and that pass lands on "has real content" or
    // "skel exists" — a no-op, so there is no loop.
    let skelTimer = null;
    const scheduleSkeletonSync = () => {
      // ONLY while the panel is on screen. Filling it on page load meant fetching and mounting
      // a dozen full product cards on the main thread of every page for a panel most visitors
      // never open — and the filled row then let predictive-search's index reset steal focus
      // into the header field, which jumped the page to the top and locked its scroll.
      if (!fs.classList.contains('r69s-open')) return;
      if (skelTimer) return;
      skelTimer = setTimeout(() => {
        skelTimer = null;
        syncRecentSkeleton();
        fillRecent();
      }, 40);
    };
    if (content && window.MutationObserver) {
      new MutationObserver(scheduleSkeletonSync).observe(content, { childList: true, subtree: true });
      // Re-wire the panel's rails on the shared drag module after every morph — each morph
      // brings fresh nodes (they carry data-r69-dragscroll in the server markup). This lives
      // HERE, inside init, because `content` only exists in this scope: the first version sat
      // at the IIFE top level, threw a ReferenceError and killed the whole search script —
      // the field stopped opening the panel at all.
      new MutationObserver(function () {
        if (window.r69DragScroll) window.r69DragScroll(content);
      }).observe(content, { childList: true, subtree: true });
    }
    if (window.r69DragScroll) window.r69DragScroll(fs);

    // Whenever the field is blank, the panel must show the empty state — the
    // predictive component can otherwise leave the last results behind.
    const showEmptyIfBlank = () => {
      if (input && (input.value || '').trim() === '' && content && emptyHTML && !content.querySelector('.r69s-search__inner')) {
        content.innerHTML = emptyHTML;
        // the re-injected empty state carries a fresh, empty recent container
        syncRecentSkeleton();
      }
    };
    const restoreEmpty = (delay) => { setTimeout(showEmptyIfBlank, delay); };

    // The header pins itself and goes solid while the panel is open. That used to be CSS-only —
    // `.header-section:has(.r69-search.is-open)` and three `:has()` branches in header.liquid — and
    // every open/close made Blink re-run those :has() walks over the 3 000-element header and then
    // restyle the whole header__columns subtree (measured 06.09.2026, collection page, CPU ×4: the
    // six :has() rules were ~50 ms of the 140 ms it cost to close the panel). A class set here costs
    // the header rules keyed on it and nothing else. The state class on the panel itself is
    // `r69s-open`, not `is-open`: that name is an argument of theme :has() rules and toggling it is
    // taxed by them (see the note in r69-wishlist.js).
    const headerAnchors = () => [fs.closest('.header-section'), document.getElementById('header-component')].filter(Boolean);
    // The pin is applied ONE FRAME after the panel changes state, not inside the tap/keypress. The
    // class turns the header section `position: sticky` (search-modal.liquid), and flipping sticky
    // ↔ static re-lays out the whole 3 000-element header: 143 ms of forced style/layout at CPU ×4
    // on the collection page (06.09.2026) — the whole remaining cost of closing the panel, and the
    // same again on opening. INP stops at the first paint after the handler, so the pin lands in the
    // next frame instead. Nothing can move in that frame: the page is scroll-locked while the panel
    // is open, and the panel itself is position: fixed. A rapid open→close→open cannot leave a stale
    // class either — the deferred call mirrors whatever state the panel is in when it runs.
    let pinTimer = 0;
    const syncHeaderPin = () => {
      if (pinTimer) return;
      pinTimer = requestAnimationFrame(() => {
        setTimeout(() => {
          pinTimer = 0;
          const on = fs.classList.contains('r69s-open');
          headerAnchors().forEach((el) => el.classList.toggle('r69-search-open', on));
        }, 0);
      });
    };
    const open = () => {
      setTop(fs);
      fs.classList.add('r69s-open');
      // The category tiles of the empty state are parked by r69-lazy.js while the panel is closed
      // (visibility: hidden — see the note there); re-arm them now that the panel is visible.
      if (window.r69Lazy) window.r69Lazy.watch(fs);
      syncHeaderPin();
      // a failed recent fetch stops the skeleton for that id-list; a fresh open retries it
      recentFailedSig = '';
      showEmptyIfBlank();
      // the row is built here, on open — never on page load
      syncRecentSkeleton();
      fillRecent();
      // The page behind the open panel does not scroll — on EVERY width, not just phones.
      // Desktop used to stay live, and scrolling with the panel open desynced the header:
      // the section is pinned (position: sticky) while the panel is open, so on close it
      // reverted to static at whatever scroll position the shopper had reached and the
      // header sat parked far above the viewport (measured: top = -2365px), only returning
      // if they happened to scroll up. Freezing the page removes the whole class of
      // desync — and there is nothing to look at behind a full-width panel anyway.
      // `r69-search-lock` uses overflow: clip, which blocks scrolling WITHOUT
      // re-establishing a scroll container, so nothing sticky is de-pinned (see the rule).
      lockScroll(true);
    };
    const close = () => {
      fs.classList.remove('r69s-open');
      syncHeaderPin();
      lockScroll(false);
    };

    // The "(N)" next to "Meklēšanas rezultāti" is rendered by the section itself from the
    // products-only fetch (r69-search-dropdown-body.liquid prints search.results_count), so it
    // is the very number the results page shows. The separate predictive-search-count request
    // and the MutationObserver that re-applied it after every morph are gone (06.09.2026).
    if (input) {
      input.addEventListener('focus', open);
      input.addEventListener('input', () => {
        const q = input.value.trim();
        // Re-open only if something closed the panel while the field kept focus (a pointerdown
        // outside). Calling open() on EVERY keystroke ran setTop() each time — two forced
        // style/layout passes on the whole document per typed letter (measured 05.09.2026 on the
        // home page, Pixel-class phone at 4x CPU: 180-200 ms of the 760-936 ms INP for a keydown).
        if (!fs.classList.contains('r69s-open')) open();
        if (q === '') { restoreEmpty(260); return; }
      });
    }
    if (resetBtn) resetBtn.addEventListener('click', () => restoreEmpty(320));

    if (closeBtn) {
      closeBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        if (input) input.value = '';
        restoreEmpty(0);
        close();
        if (input) input.blur();
      });
    }

    // pointerdown in the CAPTURE phase, not a bubbled click: a press that lands in a widget
    // which stops propagation (slideshows, galleries, app embeds) never reaches document in
    // the bubble — the owner met exactly that on desktop: the field blurred natively but the
    // panel stayed open. Capture runs before any handler can swallow the event, and
    // pointerdown fires even when no click follows (a drag, a long press).
    // Overlays opened FROM the search — the quick-add modal (+ its backdrop) and the size-guide
    // dialog — render outside `fs`. Interacting with them (X, backdrop, «Izmēru ceļvedis») must
    // NOT close the search behind them, so ignore pointerdowns that land inside an open dialog or
    // the quick-add backdrop. `fs` is not a dialog, so this never matches the search itself.
    const inSearchOverlay = (node) => {
      const el = node instanceof Element ? node : node.parentElement;
      return !!el && !!el.closest('dialog[open], .quick-add-modal__backdrop');
    };
    // Nothing to do while the panel is closed: without this guard every tap anywhere on the page
    // ran close() — 32 ms at CPU ×4 on a Pixel-class phone inside the tap's own task (trace of a
    // wishlist tap on the collection, 06.09.2026), paid by taps that had nothing to do with search.
    document.addEventListener(
      'pointerdown',
      (event) => {
        if (!fs.classList.contains('r69s-open')) return;
        if (event.target instanceof Node && !fs.contains(event.target) && !inSearchOverlay(event.target)) close();
      },
      true
    );
    document.addEventListener('keydown', (event) => {
      // Let an open overlay handle its own Escape first (it closes itself; the search stays).
      if (event.key === 'Escape' && !document.querySelector('.quick-add-modal[open], dialog.rgd[open]')) {
        close();
        input && input.blur();
      }
    });
    const reposition = () => {
      if (fs.classList.contains('r69s-open')) setTop(fs);
      // The old width-crossing unlock lived here and ran on EVERY scroll event; it exists no
      // more because the lock is no longer width-dependent — an open panel locks at any
      // width, and only close() unlocks. Keeping an unlock on the scroll path would also
      // have fought the lock it is meant to complement.
    };
    window.addEventListener('scroll', reposition, { passive: true });
    window.addEventListener('resize', reposition);
  };

  const boot = () => document.querySelectorAll('.r69-search').forEach(init);
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
})();
